import React from 'react';
import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';

const faq = [
    {
        question: "What is this?",
        answer: "This is a website that I made for fun. Suppose you can find what you want by using the ancient technique of rhabdomancy."
    },
    {
        question: "What is rhabdomancy?",
        answer:"Rhabdomancy is a divination technique which involves the use of any rod, wand, staff, stick, arrow, or the like. One method of rhabdomancy was setting a number of staffs on end and observing where they fall, to divine the direction one should travel, or to find answers to certain questions."
    },
    {
        question: "It is working?",
        answer: "No way! It is just a joke. BUT i have reports that it is working for some people. I don't know why and what misterious forces are behind this. I am glad that it is working for some people."
    },
    {
         question: "I want to thank you! \
         I Found What I've Been Searching For!",
         answer: "Oh, I am so thrilled, just buy me a <a href=\"//liberapay.com/sl45sms/donate\">beer</a>"
    },
    {
        "question": "What Rhabdomancy means?",
        "answer": "Rhabdomancy etymology is from Greek ῥαβδομαντία (rhabdomantía), from ῥαβδός (rhabdós, \"rod\") + μαντεία (manteía, \"divination\"); however, as far as i know, the practice does not referenced in any ancient Greek docs.
    }
]


const FaqPage = () => {
    return <>
                {faq.map((item) => {
                    return (
                        <div className="faq_row">
                            <h3>{item.question}</h3>
                            <div dangerouslySetInnerHTML={{__html:item.answer}} />
                            <div className="cleaner"></div>
                        </div>
                    )
                })}
    </>
}

const domContainer = document.querySelector('#faq');
const root = createRoot(domContainer);
root.render(React.createElement(FaqPage));

export default FaqPage;
